export default {
  currentSituation: 'Sit. actuelle',
  simulation: 'Simulation',
}
